import { render, staticRenderFns } from "./PresetSurfaceDecorationDialog.vue?vue&type=template&id=a134fc8c"
import script from "./PresetSurfaceDecorationDialog.vue?vue&type=script&lang=js"
export * from "./PresetSurfaceDecorationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports